<template>
  <div>
    <component
      v-bind:is="cmpName"
      :init-id="biz.bizId"
      :init-data="biz.bizData"
      :opener="opener"
    ></component>
  </div>
</template>

<script>
import Clientput from "@/views/agent/Clientput.vue";
import AgentCust from "@/views/agent/Cust.vue";
import AgentPrice from "@/views/agent/Price.vue";
``
import Customer from "@/views/document/Customer.vue";
import CustomerChange from "@/views/document/CustomerChange.vue";
import Product from "@/views/document/Product.vue";
import ProductChange from "@/views/document/ProductChange.vue";
import Vendor from "@/views/document/Vendor.vue";
import VendorChange from "@/views/document/VendorChange.vue";
import VendorApply from "@/views/document/VendorApply.vue";
import CustomerUnLock from "@/views/document/CustomerUnLock.vue";
import CustomerTempCredit from "@/views/document/CustomerTempCredit.vue";
import Agent from "@/views/document/Agent.vue";

import Otherbillar from "@/views/money/Otherbillar.vue";
import Otherbillap from "@/views/money/Otherbillap.vue";
import PayApply from "@/views/money/PayApply.vue";
import Payment from "@/views/money/Payment.vue";
import PayVerify from "@/views/money/PayVerify.vue";
import Receipt from "@/views/money/Receipt.vue";
import RecVerify from "@/views/money/RecVerify.vue";
import ReceiptApply from "@/views/money/ReceiptApply.vue";
import Othpayables from "@/views/money/Othpayables.vue";
import Othreceivables from "@/views/money/Othreceivables.vue";
import ApaccountApply from "@/views/money/Apaccountapply.vue";
import AraccountApply from "@/views/money/Araccountapply.vue";

import FeeApply from "@/views/oa/FeeApply.vue";
import FeeBudget from "@/views/oa/FeeBudget.vue";
import Fee from "@/views/oa/Fee.vue";
import Loan from "@/views/oa/Loan.vue";
import Overtime from "@/views/oa/Overtime.vue";
import Seal from "@/views/oa/Seal.vue";
import SignCard from "@/views/oa/SignCard.vue";
import Travel from "@/views/oa/Travel.vue";
import Vacation from "@/views/oa/Vacation.vue";
import EmpChange from "@/views/oa/EmpChange.vue";
import Notify from "@/views/oa/Notify.vue";
import Recruit from "@/views/oa/Recruit.vue";
import Repair from "@/views/oa/Repair.vue";
import Regulation from "@/views/oa/Regulation.vue";
import EntryApply from "@/views/oa/EntryApply.vue";
import Contract from "@/views/oa/Contract.vue";
import FixedAssets from "@/views/oa/FixedAssets.vue";
import FixedAssetsChange from "@/views/oa/FixedAssetsChange.vue";
import SuppliesApply from "@/views/oa/SuppliesApply.vue";
import VisitInner from "@/views/oa/VisitInner.vue";
import Equipment from "@/views/oa/Equipment.vue";
import EquipmentCheck from "@/views/oa/EquipmentCheck.vue";
import EquipmentChange from "@/views/oa/EquipmentChange.vue";
import AuthApply from "@/views/oa/AuthApply.vue";
import SalarysetChangeApply from "@/views/oa/SalarysetChange.vue";
import Attendance from "@/views/oa/Attendance.vue";
import AttendanceChange from "@/views/oa/AttendanceChange.vue";
import Wage from "@/views/oa/Wage.vue";
import ChangeClass from "@/views/oa/ChangeClass.vue";
import RepairClass from "@/views/oa/RepairClass.vue";
import Exam from "@/views/oa/Exam.vue";

import PurchaseIn from "@/views/purchase/In.vue";
import PurchaseInquiry from "@/views/purchase/Inquiry.vue";
import PurchaseOrder from "@/views/purchase/Order.vue";
import PurchaseReturn from "@/views/purchase/Return.vue";
import PurchaseRebate from "@/views/purchase/Rebate.vue";
import PurchaseApply from "@/views/purchase/Apply.vue";
import PurchasePrice from "@/views/purchase/Price.vue";
import PurchaseChange from "@/views/purchase/OrderChange.vue";
import SampleInquiryPrice from "@/views/purchase/SampleInquiryPrice.vue";
import SampleInquiry from "@/views/purchase/SampleInquiry.vue";
import SampleApply from "@/views/purchase/SampleApply.vue";
import Apcheck from "@/views/purchase/Apcheck.vue";

import SaleForecast from "@/views/sale/Forecast.vue";
import PlanYear from "@/views/sale/PlanYear.vue";
import SaleOrder from "@/views/sale/Order.vue";
import SaleOut from "@/views/sale/Out.vue";
import SaleQuote from "@/views/sale/Quote.vue";
import SaleReturn from "@/views/sale/Return.vue";
import SaleChange from "@/views/sale/Change.vue";
import MoveOutSeller from "@/views/sale/MoveOutSeller.vue";
import SaleActivity from "@/views/crm/Activity.vue";
import ClientVisit from "@/views/crm/ClientVisit.vue";
import ClientPut from "@/views/crm/ClientPut.vue";
import AfterSale from "@/views/crm/AfterSale.vue"
import ServeContract from "@/views/crm/ServeContract.vue"
import ServeItem from "@/views/crm/ServeItem.vue"
import SampleReply from "@/views/sale/SampleReply.vue";
import Archeck from "@/views/sale/Archeck.vue";

import StockLoss from "@/views/stock/Loss.vue";
import StockOthIn from "@/views/stock/OthIn.vue";
import StockOthOut from "@/views/stock/OthOut.vue";
import StockProfit from "@/views/stock/Profit.vue";
import PurcVerifyApply from "@/views/stock/VerifyApply.vue";
import StockGoodsLend from "@/views/stock/GoodsLend.vue";
import StockGoodsBack from "@/views/stock/GoodsBack.vue";
import StockMove from "@/views/stock/Move.vue";
import StockIn from "@/views/stock/In.vue";
import StockInChange from "@/views/stock/InChange.vue";
import Adjust from "@/views/stock/Adjust.vue";

import PurcIqc from "@/views/qc/Iqc.vue";
import PurcIqcReturn from "@/views/qc/IqcReturn.vue";
import MakeQa from "@/views/qc/Qa.vue";
import MakeQc from "@/views/qc/Qc.vue";
import MakeQe from "@/views/qc/Qe.vue";

import Demand from "@/views/plm/Demand.vue";
import DemandChange from "@/views/plm/DemandChange.vue";
import Proj from "@/views/plm/Proj.vue";
import ProjChange from "@/views/plm/ProjChange.vue";
import ProjTask from "@/views/plm/ProjTask.vue";
import ProjCheck from "@/views/plm/ProjCheck.vue";
import ProblemFeedback from "@/views/plm/ProblemFeedback.vue";
import ProblemTask from "@/views/plm/ProblemTask.vue";
import MarketReport from "@/views/plm/MarketReport.vue";
import TechnicalReport from "@/views/plm/TechnicalReport.vue";
import CostReport from "@/views/plm/CostReport.vue";
import ProjPick from "@/views/plm/ProjPick.vue";
import PlmSample from "@/views/plm/PlmSample.vue";
import Ecr from "@/views/plm/Ecr.vue";
import PlmMake from "@/views/plm/Make.vue";

import Bom from "@/views/production/Bom.vue";
import BomChange from "@/views/production/BomChange.vue";
import MakeIn from "@/views/production/In.vue";
import Make from "@/views/production/Make.vue";
import MakeChange from "@/views/production/MakeChange.vue";
import Disassemble from "@/views/production/Disassemble.vue";
import DisassembleIn from "@/views/production/DisassembleIn.vue";
import DisassemblePick from "@/views/production/DisassemblePick.vue";
import DisassembleScrap from "@/views/production/DisassembleScrap.vue";
import MakePick from "@/views/production/Pick.vue";
import MakeReturn from "@/views/production/Return.vue";
import MakeScrap from "@/views/production/Scrap.vue";
import MakeRelocation from "@/views/production/Relocation.vue";
import MakeRepair from "@/views/production/MakeRepair.vue";
import MakeCut from "@/views/production/MakeCut.vue";
import MakeCutPick from "@/views/production/MakeCutPick.vue";
import MakeCutReturn from "@/views/production/MakeCutReturn.vue";
import MakeCutScrap from "@/views/production/MakeCutScrap.vue";
import MakeCutIn from "@/views/production/MakeCutIn.vue";

import OutMakeIn from "@/views/out_prod/In.vue";
import OutMake from "@/views/out_prod/Make.vue";
import OutMakeOut from "@/views/out_prod/Out.vue";
import OutMakePick from "@/views/out_prod/Pick.vue";
import OutMakeReturn from "@/views/out_prod/Return.vue";
import OutMakeScrap from "@/views/out_prod/Scrap.vue";
import OutMakeRelocation from "@/views/out_prod/Relocation.vue";

const bizMap = {
  "agent-clientput-benchpanel": {
    cmp: "clientput",
    page: "/agent/clientput",
  },
  "clientput-benchpanel": {
    cmp: "clientput",
    page: "/agent/clientput",
  },
  "agent-agentcust-formpanel": {
    cmp: "agent-cust",
    page: "/agent/cust/:id",
  },
  "agentcust-formpanel": {
    cmp: "agent-cust",
    page: "/agent/cust/:id",
  },
  "agent-agentprice-formpanel": {
    cmp: "agent-price",
    page: "/agent/price/:id",
  },
  "agentprice-formpanel": {
    cmp: "agent-price",
    page: "/agent/price/:id",
  },
  "agent-agentinfo-formpanel": {
    cmp: "agent",
    page: "/document/agent/:id",
  },
  "agentinfo-formpanel": {
    cmp: "agent",
    page: "/document/agent/:id",
  },
  "document-customer-formpanel": {
    cmp: "customer",
    page: "/document/customer/:id",
  },
  "customer-formpanel": {
    cmp: "customer",
    page: "/document/customer/:id",
  },
  "customer-change-formpanel": {
    cmp: "customer-change",
    page: "/document/customer_change/:id",
  },
  "customerchange-formpanel": {
    cmp: "customer-change",
    page: "/document/customer_change/:id",
  },
  "document-product-formpanel": {
    cmp: "product",
    page: "/document/product/:id",
  },
  "product-formpanel": {
    cmp: "product",
    page: "/document/product/:id",
  },
  "productchange-formpanel": {
    cmp: "product-change",
    page: "/document/product_change/:id",
  },
  "product-change-formpanel": {
    cmp: "product-change",
    page: "/document/product_change/:id",
  },
  "document-vendor-formpanel": {
    cmp: "vendor",
    page: "/document/vendor/:id",
  },
  "vendor-formpanel": {
    cmp: "vendor",
    page: "/document/vendor/:id",
  },
  "vendor-change-formpanel": {
    cmp: "vendor-change",
    page: "/document/vendor_change/:id",
  },
  "vendorchange-formpanel": {
    cmp: "vendor-change",
    page: "/document/vendor_change/:id",
  },
  "sample-vendorQualificat-formpanel": {
    cmp: "vendor-apply",
    page: "/document/vendor_apply/:id",
  },
  "vendorqualifications-formpanel": {
    cmp: "vendor-apply",
    page: "/document/vendor_apply/:id",
  },
  "document-customer-unlockPanel": {
    cmp: "customer-un-lock",
  },
  "customerunlock-formpanel": {
    cmp: "customer-un-lock",
  },
  "document-customer-tempcreditpanel": {
    cmp: "customer-temp-credit",
  },
  "money-otherbillar-formpanel": {
    cmp: "otherbillar",
    page: "/money/otherbillar/:id",
  },
  "otherbillar-formpanel": {
    cmp: "otherbillar",
    page: "/money/otherbillar/:id",
  },
  "money-otherbillap-formpanel": {
    cmp: "otherbillap",
    page: "/money/otherbillap/:id",
  },
  "otherbillap-formpanel": {
    cmp: "otherbillap",
    page: "/money/otherbillap/:id",
  },
  "money-payplease-formpanel": {
    cmp: "pay-apply",
    page: "/money/payapply/:id",
  },
  "payplease-formpanel": {
    cmp: "pay-apply",
    page: "/money/payapply/:id",
  },
  "money-paybalance-formpanel": {
    cmp: "payment",
    page: "/money/payment/:id",
  },
  "paybalance-formpanel": {
    cmp: "payment",
    page: "/money/payment/:id",
  },
  "money-verification-pay-formpanel": {
    cmp: "pay-verify",
    page: "/money/payverify/:id",
  },
  "verification-pay-formpanel": {
    cmp: "pay-verify",
    page: "/money/payverify/:id",
  },
  "money-recbalance-formpanel": {
    cmp: "receipt",
    page: "/money/receipt_report_det",
  },
  "recbalance-formpanel": {
    cmp: "receipt",
    page: "/money/receipt_report_det",
  },
  "money-verification-rec-formpanel": {
    cmp: "rec-verify",
    page: "",
  },
  "verification-rec-formpanel": {
    cmp: "rec-verify",
    page: "/money/recverify/:id",
  },
  "money-recbackapply-formpanel": {
    cmp: "receipt-apply",
    page: "/money/receipt_apply/:id",
  },
  "recbackapply-formpanel": {
    cmp: "receipt-apply",
    page: "/money/receipt_apply/:id",
  },
  "money-othpayables-formpanel": {
    cmp: "othpayables",
    page: "/money/othpayables/:id",
  },
  "othpayables-formpanel": {
    cmp: "othpayables",
    page: "/money/othpayables/:id",
  },
  "money-othreceivables-formpanel": {
    cmp: "othreceivables",
    page: "/money/othreceivables/:id",
  },
  "othreceivables-formpanel": {
    cmp: "othreceivables",
    page: "/money/othreceivables/:id",
  },
  "money-apaccountapply-formpanel": {
    cmp: "apaccount-apply",
    page: "/money/apaccountapply/:id",
  },
  "apaccountapply-formpanel": {
    cmp: "apaccount-apply",
    page: "/money/apaccountapply/:id",
  },
  "money-araccountapply-formpanel": {
    cmp: "araccount-apply",
    page: "/money/araccountapply/:id",
  },
  "araccountapply-formpanel": {
    cmp: "araccount-apply",
    page: "/money/araccountapply/:id",
  },
  "oa-feeapply-formpanel": {
    cmp: "fee-apply",
    page: "/oa/fee_apply/:id",
  },
  "feeapply-formpanel": {
    cmp: "fee-apply",
    page: "/oa/fee_apply/:id",
  },
  "oa-feebudget-formpanel":{
    cmp: "fee-budget",
    page: "/oa/fee_budget/:id",
  },
  "feebudget-formpanel": {
    cmp: "fee-budget",
    page: "/oa/fee_budget/:id",
  },
  "oa-feeplease-formpanel": {
    cmp: "fee",
    page: "/oa/fee/:id",
  },
  "feeplease-formpanel": {
    cmp: "fee",
    page: "/oa/fee/:id",
  },
  "oa-loan-formpanel": {
    cmp: "loan",
    page: "/oa/loan/:id",
  },
  "loan-formpanel": {
    cmp: "loan",
    page: "/oa/loan/:id",
  },
  "oa-workovertime-formpanel": {
    cmp: "overtime",
    page: "/oa/overtime/:id",
  },
  "workovertime-formpanel": {
    cmp: "overtime",
    page: "/oa/overtime/:id",
  },
  "oa-officialseal-formpanel": {
    cmp: "seal",
    page: "/oa/seal/:id",
  },
  "officialseal-formpanel": {
    cmp: "seal",
    page: "/oa/seal/:id",
  },
  "oa-mobilesigncard-formpanel": {
    cmp: "sign-card",
    page: "/oa/signcard/:id",
  },
  "mobilesigncard-formpanel": {
    cmp: "sign-card",
    page: "/oa/signcard/:id",
  },
  "oa-outapply-formpanel": {
    cmp: "travel",
    page: "/oa/travel/:id",
  },
  "outapply-formpanel": {
    cmp: "travel",
    page: "/oa/travel/:id",
  },
  "oa-vacation-formpanel": {
    cmp: "vacation",
    page: "/oa/vacation/:id",
  },
  "vacation-formpanel": {
    cmp: "vacation",
    page: "/oa/vacation/:id",
  },
  "oa-turnposition-formpanel": {
    cmp: "emp-change",
    page: "/oa/empchange/:id",
  },
  "turnposition-formpanel": {
    cmp: "emp-change",
    page: "/oa/empchange/:id",
  },
  "oa-notify-formpanel": {
    cmp: "notify",
    page: "/oa/notify/:id",
  },
  "notify-formpanel": {
    cmp: "notify",
    page: "/oa/notify/:id",
  },
  "oa-recruitapply-formpanel": {
    cmp: "recruit",
    page: "/oa/recruit/:id",
  },
  "recruitapply-formpanel": {
    cmp: "recruit",
    page: "/oa/recruit/:id",
  },
  "oa-repairapply-formpanel": {
    cmp: "repair",
    page: "/oa/repair/:id",
  },
  "repairapply-formpanel": {
    cmp: "repair",
    page: "/oa/repair/:id",
  },
  "oa-companysystem-formpanel": {
    cmp: "regulation",
    page: "/oa/regulation/:id",
  },
  "companysystem-formpanel": {
    cmp: "regulation",
    page: "/oa/regulation/:id",
  },
  "oa-entryapply-formpanel": {
    cmp: "entry-apply",
    page: "/oa/entry_apply/:id",
  },
  "entryapply-formpanel": {
    cmp: "entry-apply",
    page: "/oa/entry_apply/:id",
  },
  "oa-contract-formpanel": {
    cmp: "contract",
    page: "/oa/contract/:id",
  },
  "contract-formpanel": {
    cmp: "contract",
    page: "/oa/contract/:id",
  },
  "oa-fixedassets-formpanel": {
    cmp: "fixed-assets",
    page: "/oa/fixed_assets/:id",
  },
  "fixedassets-formpanel": {
    cmp: "fixed-assets",
    page: "/oa/fixed_assets/:id",
  },
  "oa-fixedassetschange-formpanel": {
    cmp: "fixed-assets-change",
    page: "/oa/fixed_assets_change/:id",
  },
  "fixedassetschange-formpanel": {
    cmp: "fixed-assets-change",
    page: "/oa/fixed_assets_change/:id",
  },
  "oa-supplies-formpanel": {
    cmp: "supplies-apply",
    page: "/oa/supplies_apply/:id",
  },
  "supplies-formpanel": {
    cmp: "supplies-apply",
    page: "/oa/supplies_apply/:id",
  },
  "oa-visitinner-formpanel": {
    cmp: "visit-inner",
    page: "/oa/visit_inner/:id",
  },
  "visitinner-formpanel": {
    cmp: "visit-inner",
    page: "/oa/visit_inner/:id",
  },
  "oa-equipment-formpanel": {
    cmp: "equipment",
    page: "/oa/equipment/:id",
  },
  "equipment-formpanel": {
    cmp: "equipment",
    page: "/oa/equipment/:id",
  },
  "oa-equipmentcheck-formpanel": {
    cmp: "equipment-check",
    page: "/oa/equipment_check/:id",
  },
  "equipmentcheck-formpanel": {
    cmp: "equipment-check",
    page: "/oa/equipment_check/:id",
  },
  "equipmentchange-formpanel": {
    cmp: "equipment-change",
    page: "/oa/equipment_change/:id",
  },
  "equipment-change-formpanel": {
    cmp: "equipment-change",
    page: "/oa/equipment_change/:id",
  },
  "oa-authApply-formpanel": {
    cmp: "auth-apply",
    page: "/oa/auth_apply/:id",
  },
  "authApply-formpanel": {
    cmp: "auth-apply",
    page: "/oa/auth_apply/:id",
  },
  "hr-salarysetchangeapply-formpanel": {
    cmp: "salaryset-change-apply",
    page: "/oa/salaryset_change/:id",
  },
  "salarysetchangeapply-formpanel": {
    cmp: "salaryset-change-apply",
    page: "/oa/salaryset_change/:id",
  },
  "hr-attendance-formpanel": {
    cmp: "attendance",
    page: "/oa/attendance/:id",
  },
  "attendance-change-formpanel": {
    cmp: "attendance-change",
    page: "/oa/attendance_change/:id",
  },
  "hr-wage-formpanel": {
    cmp: "wage",
    page: "/oa/wage/:id",
  },
  "hr-changeclass-formpanel": {
    cmp: "change-class",
    page: "/oa/changeclass/:id",
  },
  "hr-repairclass-formpanel": {
    cmp: "repair-class",
    page: "/oa/repairclass/:id",
  },
  "oa-exam-formpanel": {
    cmp: "exam",
    page: "/oa/exam/:id",
  },
  "exam-formpanel": {
    cmp: "exam",
    page: "/oa/exam/:id",
  },
  "purchase-purchasein-formpanel": {
    cmp: "purchase-in",
    page: "/purchase/in/:id",
  },
  "purchasein-formpanel": {
    cmp: "purchase-in",
    page: "/purchase/in/:id",
  },
  "purchase-b2b-inquiry-formpanel": {
    cmp: "purchase-inquiry",
    page: "/purchase/inquiry/:id",
  },
  "b2b-inquiry-formpanel": {
    cmp: "purchase-inquiry",
    page: "/purchase/inquiry/:id",
  },
  "purchase-purchase-formpanel": {
    cmp: "purchase-order",
    page: "/purchase/order/:id",
  },
  "purchase-formpanel": {
    cmp: "purchase-order",
    page: "/purchase/order/:id",
  },
  "purchase-rebate-formpanel": {
    cmp: "purchase-rebate",
    page: "/purchase/rebate/:id",
  },
  "rebate-formpanel": {
    cmp: "purchase-rebate",
    page: "/purchase/rebate/:id",
  },
  "purchase-purchaseout-formpanel": {
    cmp: "purchase-return",
    page: "/purchase/return/:id",
  },
  "purchaseout-formpanel": {
    cmp: "purchase-return",
    page: "/purchase/return/:id",
  },
  "purchase-application-formpanel": {
    cmp: "purchase-apply",
    page: "/purchase/apply/:id",
  },
  "application-formpanel": {
    cmp: "purchase-apply",
    page: "/purchase/apply/:id",
  },
  "purchase-b2b-inquiryprice-formpanel": {
    cmp: "purchase-price",
    page: "/purchase/price/:id",
  },
  "b2b-inquiryprice-formpanel": {
    cmp: "purchase-price",
    page: "/purchase/price/:id",
  },
  "purchase-change-formpanel": {
    cmp: "purchase-change",
    page: "/sale/b2b_detail_purchase_change",
  },
  "purchasechange-formpanel": {
    cmp: "purchase-change",
    page: "/sale/b2b_detail_purchase_change",
  },
  "sample-inquiryprice-formpanel": {
    cmp: "sample-inquiry-price",
    page: "/purchase/sample_inquiry_price/:id",
  },
  "sampleInquiryprice-formpanel": {
    cmp: "sample-inquiry-price",
    page: "/purchase/sample_inquiry_price/:id",
  },
  "sample-sampleInquiry-formpanel": {
    cmp: "sample-inquiry",
    page: "/purchase/sample_inquiry/:id",
  },
  "sampleInquiry-formpanel": {
    cmp: "sample-inquiry",
    page: "/purchase/sample_inquiry/:id",
  },
  "sample-sampleBase-formpanel": {
    cmp: "sample-apply",
    page: "/purchase/sample_apply/:id",
  },
  "sample-formpanel": {
    cmp: "sample-apply",
    page: "/purchase/sample_apply/:id",
  },
  "purchase-purchaseReconciliation-querypanel-detail": {
    cmp: "apcheck",
    page: "/purchase/apcheck/:id",
  },
  "sale-planyear-formpanel": {
    cmp: "plan-year",
    page: "/sale/planyear/:id",
  },
  "planyear-formpanel": {
    cmp: "plan-year",
    page: "/sale/planyear/:id",
  },
  "sale-saleforecast-formpanel": {
    cmp: "sale-forecast",
    page: "/sale/forecast/:id",
  },
  "saleforecast-formpanel": {
    cmp: "sale-forecast",
    page: "/sale/forecast/:id",
  },
  "sale-sale-formpanel": {
    cmp: "sale-order",
    page: "/sale/order/:id",
  },
  "sale-formpanel": {
    cmp: "sale-order",
    page: "/sale/order/:id",
  },
  "sale-saleout-formpanel": {
    cmp: "sale-out",
    page: "/sale/out/:id",
  },
  "saleout-formpanel": {
    cmp: "sale-out",
    page: "/sale/out/:id",
  },
  "sale-quotation-formpanel": {
    cmp: "sale-quote",
    page: "/sale/quote/:id",
  },
  "quotation-formpanel": {
    cmp: "sale-quote",
    page: "/sale/quote/:id",
  },
  "sale-salein-formpanel": {
    cmp: "sale-return",
    page: "/sale/return/:id",
  },
  "salein-formpanel": {
    cmp: "sale-return",
    page: "/sale/return/:id",
  },
  "sale-change-formpanel": {
    cmp: "sale-change",
    page: "/sale/b2b_detail_osmake_change",
  },
  "salechange-formpanel": {
    cmp: "sale-change",
    page: "/sale/b2b_detail_osmake_change",
  },
  "sale-moveoutseller-formpanel": {
    cmp: "move-out-seller",
    page: "/sale/move_out_seller/:id",
  },
  "moveoutseller-formpanel": {
    cmp: "sale-move-out-seller",
    page: "/sale/move_out_seller/:id",
  },
  "crm-activity-formpanel": {
    cmp: "sale-activity",
    page: "/crm/activity/:id",
  },
  "saleactivity-formpanel": {
    cmp: "sale-activity",
    page: "/crm/activity/:id",
  },
  "crm-clientvisit-formpanel": {
    cmp: "client-visit",
    page: "/crm/client_visit/:id",
  },
  "clientvisit-formpanel": {
    cmp: "client-visit",
    page: "/crm/client_visit/:id",
  },
  "crm-clientput-formpanel": {
    cmp: "client-put",
    page: "/crm/client_put/:id",
  },
  "clientput-formpanel": {
    cmp: "client-put",
    page: "/crm/client_put/:id",
  },
  "crm-aftersale-formpanel": {
    cmp: "after-sale",
    page: "/crm/after_sale/:id",
  },
  "aftersale-formpanel": {
    cmp: "after-sale",
    page: "/crm/after_sale/:id",
  },
  "sale-serveitem-formpanel": {
    cmp: "serve-item",
    page: "/crm/serve_item/:id",
  },
  "serveitem-formpanel": {
    cmp: "serve-item",
    page: "/crm/serve_item/:id",
  },
  "sale-servecontract-formpanel": {
    cmp: "serve-contract",
    page: "/crm/serve_contract/:id",
  },
  "servecontract-formpanel": {
    cmp: "serve-contract",
    page: "/crm/serve_contract/:id",
  },
  "sample-sampleReply-formpanel": {
    cmp: "sample-reply",
    page: "/sale/sample_reply/:id",
  },
  "sampleReply-formpanel": {
    cmp: "sample-reply",
    page: "/sale/sample_reply/:id",
  },
  "sale-saleBill-querypanel-detail": {
    cmp: "archeck",
    page: "/sale/archeck/:id",
  },
  "stock-stockloss-formpanel": {
    cmp: "stock-loss",
    page: "/stock/loss/:id",
  },
  "stockloss-formpanel": {
    cmp: "stock-loss",
    page: "/stock/loss/:id",
  },
  "stock-otherin-formpanel": {
    cmp: "stock-oth-in",
    page: "/stock/othin/:id",
  },
  "otherin-formpanel": {
    cmp: "stock-oth-in",
    page: "/stock/othin/:id",
  },
  "stock-otherout-formpanel": {
    cmp: "stock-oth-out",
    page: "/stock/othout/:id",
  },
  "otherout-formpanel": {
    cmp: "stock-oth-out",
    page: "/stock/othout/:id",
  },
  "stock-stockprofit-formpanel": {
    cmp: "stock-profit",
    page: "/stock/profit/:id",
  },
  "stockprofit-formpanel": {
    cmp: "stock-profit",
    page: "/stock/profit/:id",
  },
  "stock-purcVerifyApply-formpanel": {
    cmp: "purc-verify-apply",
    page: "/stock/verifyapply/:id",
  },
  "purcVerifyApply-formpanel": {
    cmp: "purc-verify-apply",
    page: "/stock/verifyapply/:id",
  },
  "stock-goodslend-formpanel": {
    cmp: "stock-goods-lend",
    page: "/stock/goodslend/:id",
  },
  "goodslend-formpanel": {
    cmp: "stock-goods-lend",
    page: "/stock/goodslend/:id",
  },
  "stock-goodsback-formpanel": {
    cmp: "stock-goods-back",
    page: "/stock/goodsback/:id",
  },
  "goodsback-formpanel": {
    cmp: "stock-goods-back",
    page: "/stock/goodsback/:id",
  },
  "stock-appropriationinout-formpanel": {
    cmp: "stock-move",
    page: "/stock/move/:id",
  },
  "appropriationinout-formpanel": {
    cmp: "stock-move",
    page: "/stock/move/:id",
  },
  "stock-productinit-formpanel": {
    cmp: "stock-in",
    page: "/stock/in/:id",
  },
  "productinit-formpanel": {
    cmp: "stock-in",
    page: "/stock/in/:id",
  },
  "stock-prodiodetailchange-formpanel": {
    cmp: "stock-in-change",
    page: "/stock/in_change/:id",
  },
  "prodiodetailchange-formpanel": {
    cmp: "stock-in-change",
    page: "/stock/in_change/:id",
  },
  "stock-purcIqc-formpanel": {
    cmp: "purc-iqc",
    page: "/qc/iqc/:id",
  },
  "purcIqc-formpanel": {
    cmp: "purc-iqc",
    page: "/qc/iqc/:id",
  },
  "stock-purcIqcReturn-formpanel": {
    cmp: "purc-iqc-return",
    page: "/qc/iqc_return/:id",
  },
  "purcIqcReturn-formpanel": {
    cmp: "purc-iqc-return",
    page: "/qc/iqc_return/:id",
  },
  "stock-productwhmonthadjust-formpanel": {
    cmp: "product-wh-month-adjust",
    page: "/stock/adjust/:id",
  },
  "productwhmonthadjust-formpanel": {
    cmp: "product-wh-month-adjust",
    page: "/stock/adjust/:id",
  },
  "qc-makefqc-formpanel": {
    cmp: "make-qa",
    page: "/qc/qa/:id",
  },
  "makefqc-formpanel": {
    cmp: "make-qa",
    page: "/qc/qa/:id",
  },
  "qc-makeqc-formpanel": {
    cmp: "make-qc",
    page: "/qc/qc/:id",
  },
  "makeqc-formpanel": {
    cmp: "make-qc",
    page: "/qc/qc/:id",
  },
  "qc-makeqe-formpanel": {
    cmp: "make-qe",
    page: "/qc/qe/:id",
  },
  "makeqe-formpanel": {
    cmp: "make-qe",
    page: "/qc/qe/:id",
  },
  "make-routing-formpanel": {
    cmp: "bom",
  },
  "plm-demand-formpanel":{
    cmp: "demand",
    page: "/plm/demand/:id",
  },
  "demand-formpanel":{
    cmp: "demand",
    page: "/plm/demand/:id",
  },
  "demand-change-formpanel":{
    cmp: "demand-change",
    page: "/plm/demand_change/:id",
  },
  "demandchange-formpanel":{
    cmp: "demand-change",
    page: "/plm/demand_change/:id",
  },
  "plm-proj-formpanel":{
    cmp: "proj",
    page: "/plm/proj/:id",
  },
  "plmproj-formpanel":{
    cmp: "proj",
    page: "/plm/proj/:id",
  },
  "proj-change-formpanel":{
    cmp: "proj-change",
    page: "/plm/proj_change/:id",
  },
  "projchange-formpanel":{
    cmp: "proj-change",
    page: "/plm/proj_change/:id",
  },
  "plm-projtask-formpanel":{
    cmp: "proj-task",
    page: "/plm/proj_task/:id",
  },
  "plmprojtask-formpanel":{
    cmp: "proj-task",
    page: "/plm/proj_task/:id",
  },
  "plm-projcheck-formpanel":{
    cmp: "proj-check",
    page: "/plm/proj_check/:id",
  },
  "plmprojcheck-formpanel":{
    cmp: "proj-check",
    page: "/plm/proj_check/:id",
  },
  "plm-problemfeedback-formpanel":{
    cmp: "problem-feedback",
    page: "/plm/problem_feedback/:id",
  },
  "problemfeedback-formpanel":{
    cmp: "problem-feedback",
    page: "/plm/problem_feedback/:id",
  },
  "plm-problemtask-formpanel":{
    cmp: "problem-task",
    page: "/plm/problem_task/:id",
  },
  "problemtask-formpanel":{
    cmp: "problem-task",
    page: "/plm/problem_task/:id",
  },
  "plm-technicalanalysereport-formpanel":{
    cmp: "technical-report",
    page: "/plm/technical_report/:id",
  },
  "technicalanalysereport-formpanel":{
    cmp: "technical-report",
    page: "/plm/technical_report/:id",
  },

  "plm-costanalysereport-formpanel":{
    cmp: "cost-report",
    page: "/plm/cost_report/:id",
  },
  "costanalysereport-formpanel":{
    cmp: "cost-report",
    page: "/plm/cost_report/:id",
  },

  "plm-marketanalysereport-formpanel":{
    cmp: "market-report",
    page: "/plm/market_report/:id",
  },
  "marketanalysereport-formpanel":{
    cmp: "market-report",
    page: "/plm/market_report/:id",
  },

  "plm-projpick-formpanel":{
    cmp: "proj-pick",
    page: "/plm/proj_pick/:id",
  },
  "projpick-formpanel":{
    cmp: "proj-pick",
    page: "/plm/proj_pick/:id",
  },

  "plm-sample-formpanel":{
    cmp: "plm-sample",
    page: "/plm/plm_sample/:id",
  },
  "plmsample-formpanel":{
    cmp: "plm-sample",
    page: "/plm/plm_sample/:id",
  },

  "plm-ecr-formpanel":{
    cmp: "ecr",
    page: "/plm/ecr/:id",
  },
  "cnr-formpanel":{
    cmp: "ecr",
    page: "/plm/ecr/:id",
  },

  "plm-make-formpanel":{
    cmp: "make",
    page: "/plm/make/:id",
  },
  "plmmake-formpanel":{
    cmp: "make",
    page: "/plm/make/:id",
  },
  "make-bom-formpanel": {
    cmp: "bom",
    page: "/production/bom/:id",
  },
  "bom-formpanel": {
    cmp: "bom",
    page: "/production/bom/:id",
  },
  "routing-change-formpanel": {
    cmp: "bom-change",
    page: "/production/bom_change/:id",
  },
  "routingchange-formpanel": {
    cmp: "bom-change",
    page: "/production/bom_change/:id",
  },
  "make-makein-formpanel": {
    cmp: "make-in",
    page: "/out_prod/s2s_turn_os_make_in",
  },
  "makein-formpanel": {
    cmp: "make-in",
    page: "/out_prod/s2s_turn_os_make_in",
  },
  "make-makebase-formpanel": {
    cmp: "make",
    page: "/production/make/:id",
  },
  "makebase-formpanel": {
    cmp: "make",
    page: "/production/make/:id",
  },
  "make-formpanel": {
    cmp: "make",
    page: "/production/make/:id",
  },
  "make-change-formpanel": {
    cmp: "make-change",
    page: "/production/make_change/:id",
  },
  "make-makedisassemble-formpanel": {
    cmp: "disassemble",
    page: "/production/disassemble/:id",
  },
  "makedisassemble-formpanel": {
    cmp: "disassemble",
    page: "/production/disassemble/:id",
  },
  "make-makedisassemblepick-formpanel": {
    cmp: "make-disassemble-pick",
    page: "/production/disassemble_pick/:id",
  },
  "makedisassemblepick-formpanel": {
    cmp: "make-disassemble-pick",
    page: "/production/disassemble_pick/:id",
  },
  "make-makedisassemblescrap-formpanel": {
    cmp: "make-disassemble-scrap",
    page: "/production/disassemble_scrap/:id",
  },
  "makedisassemblescrap-formpanel": {
    cmp: "make-disassemble-scrap",
    page: "/production/disassemble_scrap/:id",
  },
  "make-makedisassembin-formpanel": {
    cmp: "make-disassemble-in",
    page: "/production/disassemble_in/:id",
  },
  "makedisassembin-formpanel": {
    cmp: "make-disassemble-in",
    page: "/production/disassemble_in/:id",
  },
  "make-makepick-formpanel": {
    cmp: "make-pick",
    page: "/production/pick/:id",
  },
  "makepick-formpanel": {
    cmp: "make-pick",
    page: "/production/pick/:id",
  },
  "make-makereturn-formpanel": {
    cmp: "make-return",
    page: "/production/return/:id",
  },
  "makereturn-formpanel": {
    cmp: "make-return",
    page: "/production/return/:id",
  },
  "make-makescrap-formpanel": {
    cmp: "make-scrap",
    page: "/production/scrap/:id",
  },
  "makescrap-formpanel": {
    cmp: "make-scrap",
    page: "/production/scrap/:id",
  },
  "make-relocation-formpanel": {
    cmp: "make-relocation",
    page: "/production/relocation/:id",
  },
  "makerelocation-formpanel": {
    cmp: "make-relocation",
    page: "/production/relocation/:id",
  },
  "make-makeRepair-formpanel": {
    cmp: "make-repair",
    page: "/production/make_repair/:id",
  },
  "makerepair-formpanel": {
    cmp: "make-repair",
    page: "/production/make_repair/:id",
  },
  "make-makecut-formpanel": {
    cmp: "make-cut",
    page: "/production/make_cut/:id",
  },
  "makecut-formpanel": {
    cmp: "make-cut",
    page: "/production/make_cut/:id",
  },
  "make-makecutpick-formpanel": {
    cmp: "make-cut-pick",
    page: "/production/make_cut_pick/:id",
  },
  "makecutpick-formpanel": {
    cmp: "make-cut-pick",
    page: "/production/make_cut_pick/:id",
  },
  "make-makecutreturn-formpanel": {
    cmp: "make-cut-return",
    page: "/production/make_cut_return/:id",
  },
  "makecutreturn-formpanel": {
    cmp: "make-cut-return",
    page: "/production/make_cut_return/:id",
  },
  "make-makecutscrap-formpanel": {
    cmp: "make-cut-scrap",
    page: "/production/make_cut_scrap/:id",
  },
  "makecutscrap-formpanel": {
    cmp: "make-cut-scrap",
    page: "/production/make_cut_scrap/:id",
  },
  "make-makecutin-formpanel": {
    cmp: "make-cut-in",
    page: "/production/make_cut_in/:id",
  },
  "makecutin-formpanel": {
    cmp: "make-cut-in",
    page: "/production/make_cut_in/:id",
  },
  "osmake-osmakecheckin-formpanel": {
    cmp: "out-make-in",
    page: "/out_prod/in/:id",
  },
  "osmakecheckin-formpanel": {
    cmp: "out-make-in",
    page: "/out_prod/in/:id",
  },
  "osmakein-formpanel": {
    cmp: "out-make-in",
    page: "/out_prod/in/:id",
  },
  "osmake-osmake-formpanel": {
    cmp: "out-make",
    page: "/sale/b2b_detail_osmake",
  },
  "osmake-formpanel": {
    cmp: "out-make",
    page: "/sale/b2b_detail_osmake",
  },
  "osmake-osmakecheckreturn-formpanel": {
    cmp: "out-make-out",
    page: "/out_prod/out/:id",
  },
  "osmakecheckreturn-formpanel": {
    cmp: "out-make-out",
    page: "/out_prod/out/:id",
  },
  "osmake-osmakepick-formpanel": {
    cmp: "out-make-pick",
    page: "/out_prod/pick/:id",
  },
  "osmakepick-formpanel": {
    cmp: "out-make-pick",
    page: "/out_prod/pick/:id",
  },
  "osmake-osmakereturn-formpanel": {
    cmp: "out-make-return",
    page: "/out_prod/return/:id",
  },
  "osmakereturn-formpanel": {
    cmp: "out-make-return",
    page: "/out_prod/return/:id",
  },
  "osmake-osmakescrap-formpanel": {
    cmp: "out-make-scrap",
    page: "/out_prod/scrap/:id",
  },
  "osmakescrap-formpanel": {
    cmp: "out-make-scrap",
    page: "/out_prod/scrap/:id",
  },
  "osmake-relocation-formpanel": {
    cmp: "out-make-relocation",
    page: "/out_prod/relocation/:id",
  },
  "osmakerelocation-formpanel": {
    cmp: "out-make-relocation",
    page: "/out_prod/relocation/:id",
  },
};

export default {
  components: {
    Clientput,
    AgentCust,
    AgentPrice,
    Agent,
    Customer,
    CustomerChange,
    Product,
    ProductChange,
    Vendor,
    VendorChange,
    VendorApply,
    CustomerUnLock,
    CustomerTempCredit,
    Otherbillar,
    Otherbillap,
    PayApply,
    Payment,
    PayVerify,
    Receipt,
    RecVerify,
    ReceiptApply,
    Othpayables,
    Othreceivables,
    ApaccountApply,
    AraccountApply,
    FeeApply,
    FeeBudget,
    Fee,
    Loan,
    Overtime,
    Seal,
    SignCard,
    Travel,
    Vacation,
    EmpChange,
    Notify,
    Recruit,
    Repair,
    Regulation,
    EntryApply,
    Contract,
    FixedAssets,
    FixedAssetsChange,
    SuppliesApply,
    VisitInner,
    Equipment,
    EquipmentCheck,
    EquipmentChange,
    AuthApply,
    SalarysetChangeApply,
    Attendance,
    AttendanceChange,
    Wage,
    ChangeClass,
    RepairClass,
    Exam,
    PurchaseIn,
    PurchaseInquiry,
    PurchaseOrder,
    PurchaseReturn,
    PurchaseRebate,
    PurchaseApply,
    PurchasePrice,
    PurchaseChange,
    SampleInquiryPrice,
    SampleApply,
    Apcheck,
    SampleInquiry,
    SaleForecast,
    PlanYear,
    SaleOrder,
    SaleOut,
    SaleQuote,
    SaleReturn,
    SaleChange,
    MoveOutSeller,
    SaleActivity,
    ClientVisit,
    ClientPut,
    AfterSale,
    ServeContract,
    ServeItem,
    SampleReply,
    Archeck,
    StockLoss,
    StockOthIn,
    StockOthOut,
    StockProfit,
    PurcVerifyApply,
    StockGoodsLend,
    StockGoodsBack,
    StockMove,
    StockIn,
    StockInChange,
    Adjust,
    PurcIqc,
    PurcIqcReturn,
    MakeQa,
    MakeQc,
    MakeQe,
    Demand,
    DemandChange,
    Proj,
    ProjChange,
    ProjTask,
    ProjCheck,
    ProblemFeedback,
    ProblemTask,
    MarketReport,
    TechnicalReport,
    CostReport,
    ProjPick,
    PlmSample,
    Ecr,
    PlmMake,
    Bom,
    BomChange,
    MakeIn,
    Make,
    MakeChange,
    Disassemble,
    DisassembleIn,
    DisassemblePick,
    DisassembleScrap,
    MakePick,
    MakeReturn,
    MakeScrap,
    MakeRelocation,
    MakeRepair,
    MakeCut,
    MakeCutPick,
    MakeCutReturn,
    MakeCutScrap,
    MakeCutIn,
    OutMakeIn,
    OutMake,
    OutMakeOut,
    OutMakePick,
    OutMakeReturn,
    OutMakeScrap,
    OutMakeRelocation
  },
  props: {
    biz: Object,
    opener: String,
  },
  data() {
    return {
      cmpName: "div",
    };
  },
  watch: {
    biz(newVal) {
      var config;
      if (newVal) {
        config = bizMap[newVal.viewType];
      }
      this.cmpName = config ? config.cmp : "div";
      if (config) {
        this.$emit("matched", config);
      }
    },
  },
};
</script>